import styled from "styled-components"
import media from "styled-media-query"

import { StarHalf as Star } from "@styled-icons/fa-regular/StarHalf"

import AniLink from "gatsby-plugin-transition-link/AniLink"

export const Wrapper = styled.div`
  width: 100%;

  ${media.lessThan("large")`
  `}

  section:nth-of-type(2) {
    margin-bottom: 40px;
  }
`

export const Content = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${media.greaterThan("1080px")`
    margin-bottom: 10px;
  `}

  ${media.greaterThan("1280px")`
    max-width: 1260px;
  `}
`

export const Infos = styled.div`
  width: 100%;
  padding: 0 10px;

  ${media.lessThan("980px")`
    width: 100%;
    padding: 0 25px;
  `}

  ${media.lessThan("500px")`
    padding: 0 0;
  `}
`

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;

  p:nth-of-type(1) {
    width: 82%;
    margin-bottom: 20px;
  }

  ${media.lessThan("1059px")`
  p:nth-of-type(1) {
    width: 100%;
    margin-bottom: 20px;
  }
  `}

  ${media.lessThan("500px")`
  p, p:nth-of-type(1) {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  `}
`

export const Title = styled.h1`
  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: normal;
  font-size: 24px;
  padding: 0px 18px;
  line-height: 48px;
  align-self: flex-start;
  color: var(--titleHomeColor);
  margin: 20px 0;

  border-radius: 4px;

  ${media.greaterThan("900px")`
    margin-left: 25px;
    font-size: 28px;
  `}

  ${media.greaterThan("1080px")`
    margin: 30px 35px;
    font-size: 30px;
  `}

  ${media.greaterThan("1110px")`
    margin: 30px 30px;
  `}

  ${media.greaterThan("1280px")`
    margin: 30px 30px;
    font-size: 32px;
  `}


  ${media.lessThan("900px")`
    text-align: center;
  `}

  ${media.lessThan("small")`
    align-self: center;
  `}
`
export const Starred = styled(Star)`
  color: var(--titleHomeColor);
  width: 34px;
  margin-right: -5px;
`

export const Highlights = styled.div`
  display: flex;
  align-items: center;

  height: auto;
  width: 92%;
  margin: 0 auto;
  align-items: flex-start;

  ${media.greaterThan("1380px")`
    width: 98%;
  `}

  ${media.lessThan("1040px")`
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
  `}
`

export const Secondary = styled.section`
display: flex;
height: auto;

${media.lessThan("1000px")`
  margin-top: 30px;
  width: 100%;
  align-self: center;

  section {
    height: auto;
  }
`}

${media.greaterThan("680px")`
  align-items: center;
  justify-content: center;
  margin-top: 25px;
  height: auto;
`}

${media.greaterThan("1040px")`
  width: 40%;
  flex-direction: column;
  margin-top: 0;
`}

  ${media.greaterThan("1180px")`
    width: 36%;
  `}

  ${media.lessThan("680px")`
    flex-direction: column;
  `}

  ${media.lessThan("500px")`
    margin-top: 25px;
    height: auto;
  `}
`

export const LastPosts = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  ${media.lessThan("1200px")`
    justify-content: center;
  `}
`

export const Contacts = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  section:nth-child(1) {
    margin-right: 150px;
  }

  ${media.lessThan("medium")`
    section:nth-child(1) {
      margin-right: 60px;
    }
  `}
`

export const Contact = styled.section`
  margin-top: 35px;
`

export const Social = styled.ul`
  display: flex;
  align-items: center;
  margin-top: 10px;

  li:not(:last-child) {
    margin-right: 20px;
  }

  li:nth-child(1) {
    width: 40px;
  }

  li:nth-child(2) {
    width: 30px;
  }

  li:nth-child(3) {
    width: 42px;
  }
`

export const SocialItem = styled.li`
  svg {
    color: var(--socialIcons);
  }
`

export const ContainerButton = styled(AniLink)`
  width: 100%;
  display: flex;
  justify-content: center;

  margin: 10px 0;
`

export const AllPosts = styled.button`
  width: 300px;
  height: 50px;
  border: none;

  background: #00d07e;
  border-radius: 5px;
  box-shadow: 1.5px 1.5px 1px 0px #0002;
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #ffffff;

  ${media.lessThan("large")`
    width: 320px;
    height: 50px;
  `}

  ${media.lessThan("small")`
    width: 85%;
    height: 45px;
    font-size: 18px;
  `}
`

export const Sugestions = styled.div`
  width: 100%;
  height: 450px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 10px 40px;

  ${media.lessThan("medium")`
    height: 380px;
  `}

  ${media.lessThan("530px")`
    height: 580px;
    padding: 10px 10px 30px;
  `}

  ${media.greaterThan("400px")`
    justify-content: space-around;
  `}

  ${media.greaterThan("1110px")`
    height: 420px;
  `}

  ${media.lessThan("440px")`
    margin-top: 15px;
    height: 615px;
  `}

  ${media.greaterThan("1080px")`
    margin-top: 35px;
  `}

  ${media.greaterThan("1110px")`
    margin-top: 20px;
  `}

  ${media.greaterThan("1200px")`
    margin-top: 12px;
  `}
`
export const CommunityText = styled.div``

export const CommunityTitle = styled.h1`
  font-weight: 500;
  font-size: 34px;
  line-height: 46px;
  text-align: center;
  width: 100%;

  color: var(--titleHomeColor);

  ${media.lessThan("medium")`
  font-size: 32px;
`}

  ${media.lessThan("440px")`
  font-size: 28px;
  line-height: 40px;
`}
`

export const CommunitySub = styled.h3`
  font-weight: normal;
  font-size: 22px;
  line-height: 29px;
  text-align: center;
  width: 100%;
  margin-top: 24px;

  color: var(--texts);

  ${media.lessThan("medium")`
    font-size: 18px;
  `}

  ${media.lessThan("530px")`
    margin-top: 20px;
  `}

  ${media.lessThan("440px")`
    font-size: 16px;
    padding: 0 10px;
  `}

  ${media.lessThan("340px")`
    font-size: 16px;
    padding: 0 12px;
  `}
`
